module.exports = __webpack_public_path__ + "img/tokens_white.0c2dd4f3.svg";